import { render, staticRenderFns } from "./TestimonialCard.vue?vue&type=template&id=1250a7a6&"
import script from "./TestimonialCard.vue?vue&type=script&lang=js&"
export * from "./TestimonialCard.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialCard.vue?vue&type=style&index=0&id=1250a7a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports